/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryHook} from '../types'
import {getNearbyToken} from '../api'

 export const useQueryGetNearbyToken = createReactQueryHook('getNearbyToken', getNearbyToken)
